import { useEffect, useState } from "react";

export interface MiniPlayerState {
  itemId: string;
  title: string;
  thumbnail: string | null;
  position: number;
  duration: number;
}

let _state: MiniPlayerState | null = null;
const _listeners = new Set<() => void>();

export const playerStore = {
  get: (): MiniPlayerState | null => _state,
  set: (s: MiniPlayerState | null): void => {
    _state = s;
    _listeners.forEach(fn => fn());
  },
  update: (partial: Partial<MiniPlayerState>): void => {
    if (_state) {
      _state = { ..._state, ...partial };
      _listeners.forEach(fn => fn());
    }
  },
  subscribe: (fn: () => void): (() => void) => {
    _listeners.add(fn);
    return () => { _listeners.delete(fn); };
  },
};

export function useMiniPlayer(): MiniPlayerState | null {
  const [state, setState] = useState<MiniPlayerState | null>(playerStore.get());
  useEffect(() => playerStore.subscribe(() => setState(playerStore.get())), []);
  return state;
}
